<template>
  <b-card no-body>
    <b-card-body>
      <b-row>
        <b-col
          cols="12"
          md="12"
        >
          <b-row>
            <b-col
              cols="12"
              md="4"
            >
              <b-list-group>
                <list-item
                  title="Talep Başlığı"
                  :value="dataList.title"
                />
                <list-item
                  title="Talep No"
                  :value="dataList.onumber"
                />
                <list-item
                  title="Tedarikçi"
                  :value="dataList.suppliers"
                />
              </b-list-group>
            </b-col>
            <b-col
              cols="12"
              md="4"
            >
              <b-list-group>
                <list-item
                  title="Başlangıç"
                  :value="moment(dataList.sdate).format('DD.MM.YYYY')"
                />
                <list-item
                  title="Bitiş"
                  :value="moment(dataList.edate).format('DD.MM.YYYY')"
                />
                <list-item
                  title="Oluşturan"
                  :value="dataList.username"
                />
              </b-list-group>
            </b-col>

            <b-col
              cols="12"
              md="4"
            >
              <b-list-group>
                <list-item
                  title="Onay Tarihi"
                  :value="moment(dataList.confirmed).format('DD.MM.YYYY')"
                />
                <list-item
                  title="Onay Tarihi"
                  :value="moment(dataList.created).format('DD.MM.YYYY')"
                />
                <list-item
                  title="Durum"
                  :value="dataList.purchase_offer_status"
                />
              </b-list-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card-body>
    <b-row>
      <b-col
        cols="12"
        md="12"
      >
        <b-table
          responsive="sm"
          hover
          class="font-small-3"
          :fields="fields"
          :items="dataList.lines.items"
          striped
        >
          <template #cell(stocks)="data">
            <div v-if="data.item.scode">
              <small class="text-warning">{{ data.item.scode }}</small>
            </div>
            {{ data.item.stocks }}
            <div v-if="data.item.stock_groups">
              <small class="text-primary">{{ data.item.stock_groups }}</small>
            </div>
          </template>
          <template #cell(amount)="data">
            {{ data.item.amount | toNumber }} <b class="text-primary">{{ data.item.units }}</b>
          </template>
          <template #cell(stock_amount)="data">
            {{ data.item.stock_amount | toNumber }} <b class="text-primary">{{ data.item.units }}</b>
          </template>
          <template #cell(diff)="data">
            <div>
              <b-badge
                small
                :variant="data.item.stock_amount >= data.item.amount ? 'light-success' : 'light-danger'"
              >
                <feather-icon
                  :icon="data.item.stock_amount >= data.item.amount ? 'CheckIcon' : 'ArrowDownIcon'"
                  style="margin-right: 3%"
                />
                <template v-if="Number(data.item.stock_amount) === Number(data.item.amount)">
                  Tamamlandı
                </template>
                <template v-if="Number(data.item.stock_amount) > Number(data.item.amount)">
                  <b>{{ data.item.amount - data.item.stock_amount | toNumber }} {{ data.item.units }} </b>
                  Fazladan Teslimat
                </template>
                <template v-if="Number(data.item.stock_amount) < Number(data.item.amount)">
                  <b>{{ data.item.amount - data.item.stock_amount | toNumber }} {{ data.item.units }} </b>
                  Eksik Teslimat
                </template>

              </b-badge>
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import {
  BCard, BTable, BBadge, BRow, BCol, BListGroup, BCardBody,
} from 'bootstrap-vue'
import ListItem from '@/views/Admin/Customers/View/ListItem.vue'

export default {
  name: 'PurchaseOfferCompDetailTable',
  components: {
    ListItem,
    BCard,
    BTable,
    BBadge,
    BRow,
    BCol,
    BListGroup,
    BCardBody,
  },
  data() {
    return {
      currentPage: 1,
      perPage: this.$store.state.app.perPage,
      fields: [
        {
          key: 'stocks',
          label: 'Stok Kartı',
        },
        {
          key: 'amount',
          label: 'Talep Miktarı',
          thClass: 'width-200 text-nowrap',
          tdClass: 'width-200 text-nowrap',
        },
        {
          key: 'stock_amount',
          label: 'Gerçekleşen',
          thClass: 'width-200 text-nowrap',
          tdClass: 'width-200 text-nowrap',
        },
        {
          key: 'diff',
          label: 'Durum',
          thClass: 'width-200 text-nowrap',
          tdClass: 'width-200 text-nowrap',
        },
      ],
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['purchaseOffers/purchaseOfferCompleted']
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('purchaseOffers/getPurchaseOfferStatusList', { id: this.$route.params.id })
    },
  },
}
</script>
